import Swiper from 'swiper'
import ld from 'lodash'
let __ = ld.noConflict()


document.addEventListener('DOMContentLoaded', () => {
  const sliderWrappers = document.querySelectorAll('.mtt-categories')

  if (sliderWrappers.length > 0) {
    sliderWrappers.forEach(sliderWrapper => {
      const swiperElement = sliderWrapper.querySelector('.swiper')
      let swiperInitialized = false

      const swiperOptions = {
        init: false,
        speed: 800,
        spaceBetween: 16,
        slidesPerView: 1.1,
        watchOverflow: true,
        grabCursor: true,
        breakpoints: {
          501: {
            slidesPerView: 1.5,
          },
          651: {
            slidesPerView: 2,
          }
        }
      }

      let swiper = new Swiper(swiperElement, swiperOptions)

      if (getScreenWidth() <= 760) {
        swiper.init()
        swiperInitialized = true
      }

      window.addEventListener('resize', __.debounce(() => {
        if (getScreenWidth() <= 760) {
          if (!swiperInitialized) {
            swiper = new Swiper(swiperElement, swiperOptions)
            swiper.init()
            swiperInitialized = true
          }
        } else {
          if (swiperInitialized) {
            swiper.destroy(true, true)
            swiperInitialized = false
          }
        }
      }, 200))
    })
  }
})

function getScreenWidth () {
  return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
}
